import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { RootState } from '../utilities';

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
